
export enum NumberingTags {
    Number =            '[Numer]',
    Day =               '[D]',
    DayOrder =          '[*D]',
    DayDouble =         '[DD]',
    DayDoubleOrder =    '[*DD]',
    Month =             '[M]',
    MonthOrder =        '[*M]',
    MonthDouble =       '[MM]',
    MonthDoubleOrder =  '[*MM]',
    Year =              '[RR]',
    YearOrder =         '[*RR]',
    YearFull =          '[RRRR]',
    YearFullOrder =     '[*RRRR]'
}

export function translateTags(currentDate: Date) {
    return {
        [NumberingTags.Number]: '(auto)',
        [NumberingTags.Day]: currentDate.getDate(),
        [NumberingTags.DayOrder]: currentDate.getDate(),
        [NumberingTags.DayDouble]: `${currentDate.getDate()}`.replace(/^(\d)$/, '0$1'),
        [NumberingTags.DayDoubleOrder]: `${currentDate.getDate()}`.replace(/^(\d)$/, '0$1'),
        [NumberingTags.Month]: currentDate.getMonth() + 1,
        [NumberingTags.MonthOrder]: currentDate.getMonth() + 1,
        [NumberingTags.MonthDouble]: `${currentDate.getMonth() + 1}`.replace(/^(\d)$/, '0$1'),
        [NumberingTags.MonthDoubleOrder]: `${currentDate.getMonth() + 1}`.replace(/^(\d)$/, '0$1'),
        [NumberingTags.Year]: currentDate.getFullYear().toString().substr(-2),
        [NumberingTags.YearOrder]: currentDate.getFullYear().toString().substr(-2),
        [NumberingTags.YearFull]: currentDate.getFullYear(),
        [NumberingTags.YearFullOrder]: currentDate.getFullYear()
    };
}

export function parseNumberingFormat(currentDate: Date, format: string): string {
    const translatedTags: Record<string, string | number> = translateTags(currentDate);
    for (const tag in translatedTags) {
        format = format.split(tag).join(String(translatedTags[tag]));
    }
    return format;
}
